import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
    align-items: baseline;
`;

export const Text = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  text-align: left;
  color: #ffffff;
`;

export const ImageWrapper = styled.div`
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
